var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoChatHistory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 747,
    height: 454,
    viewBox: "0 0 747 454",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1133_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M699.802 403.272C699.462 401.374 699.61 351.701 699.721 323.819C699.765 313.58 691.465 305.258 681.21 305.258H314.232C304.008 305.258 295.721 313.537 295.721 323.751V432.658C295.721 442.873 304.008 451.152 314.232 451.152H681.29C691.515 451.152 699.802 442.873 699.802 432.658V428.96L744.229 437.929L699.802 403.272Z",
    fill: "#AC1E58",
    stroke: "#AC1E58",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0311 164.372C66.3951 162.337 66.1977 80.1099 66.0866 42.402C66.0558 32.169 74.3551 23.8594 84.5981 23.8594H451.601C461.825 23.8594 470.112 32.1382 470.112 42.3527V193.751C470.112 203.966 461.825 212.245 451.601 212.245H84.5426C74.318 212.245 66.0311 203.966 66.0311 193.751V190.053L21.6035 199.022L66.0311 164.365V164.372Z",
    fill: "#AC1E58",
    stroke: "#AC1E58",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.97 383.116C680.63 381.218 680.778 331.544 680.889 303.663C680.933 293.424 672.633 285.102 662.378 285.102H295.4C285.176 285.102 276.889 293.38 276.889 303.595V412.502C276.889 422.717 285.176 430.995 295.4 430.995H662.458C672.683 430.995 680.97 422.717 680.97 412.502V408.803L725.397 417.773L680.97 383.116Z",
    fill: "white",
    stroke: "#AC1E58",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2049 144.215C47.569 142.181 47.3715 59.9536 47.2604 22.2458C47.2296 12.0128 55.5289 3.70312 65.7719 3.70312H432.774C442.999 3.70312 451.286 11.982 451.286 22.1964V173.595C451.286 183.81 442.999 192.088 432.774 192.088H65.7164C55.4919 192.088 47.2049 183.81 47.2049 173.595V169.896L2.77734 178.866L47.2049 144.209V144.215Z",
    fill: "white",
    stroke: "#AC1E58",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.648 332.859C609.079 332.859 630.675 332.859 652.42 332.828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.648 332.859C609.079 332.859 630.675 332.859 652.42 332.828",
    stroke: "black",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.252 332.828C441.857 332.859 490.604 332.859 539.085 332.853Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.252 332.828C441.857 332.859 490.604 332.859 539.085 332.853",
    stroke: "black",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.471 332.828C327.086 332.859 348.683 332.859 370.316 332.828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.471 332.828C327.086 332.859 348.683 332.859 370.316 332.828",
    stroke: "black",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.471 388.539C351.768 388.336 398.047 388.336 444.239 388.459Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.471 388.539C351.768 388.336 398.047 388.336 444.239 388.459",
    stroke: "black",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.621 148.843C254.152 148.763 270.676 148.701 287.207 148.664Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.621 148.843C254.152 148.763 270.676 148.701 287.207 148.664",
    stroke: "black",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8613 148.844C120.998 148.542 167.276 148.542 214.049 148.844Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8613 148.844C120.998 148.542 167.276 148.542 214.049 148.844",
    stroke: "black",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.162 95.4219C322.773 95.5267 371.52 95.5267 420.81 95.4219Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.162 95.4219C322.773 95.5267 371.52 95.5267 420.81 95.4219",
    stroke: "black",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8613 95.4219C132.722 95.5267 191.341 95.5267 249.924 95.4219Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8613 95.4219C132.722 95.5267 191.341 95.5267 249.924 95.4219",
    stroke: "black",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.215 41.9609C391.821 41.9733 404.421 41.9856 417.028 42.0041Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.215 41.9609C391.821 41.9733 404.421 41.9856 417.028 42.0041",
    stroke: "black",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.311 42.0043C241.939 41.8995 294.388 41.8995 346.541 41.9365Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.311 42.0043C241.939 41.8995 294.388 41.8995 346.541 41.9365",
    stroke: "black",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0781 42.0005C101.869 41.8957 133.955 41.8957 165.776 42.0005Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0781 42.0005C101.869 41.8957 133.955 41.8957 165.776 42.0005",
    stroke: "black",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.932 145.688C310.232 145.659 310.506 145.703 310.765 145.823L310.807 145.842L310.851 145.854C311.054 145.906 311.239 145.994 311.407 146.122L311.57 146.264L311.881 146.574L311.888 146.58L311.894 146.587C312.179 146.852 312.387 147.166 312.515 147.529C312.552 147.731 312.601 147.976 312.636 148.159C312.651 148.561 312.573 148.936 312.393 149.296C312.265 149.474 312.142 149.651 312.022 149.825C311.836 150.037 311.624 150.188 311.371 150.284L311.33 150.3L311.292 150.322C311.06 150.461 310.8 150.536 310.517 150.541H310.497L310.477 150.543C310.176 150.572 309.902 150.528 309.644 150.408L309.602 150.39L309.558 150.378L309.36 150.313C309.233 150.262 309.113 150.195 309.001 150.109L308.838 149.968L308.515 149.645L308.408 149.541C308.176 149.299 308.004 149.018 307.893 148.7C307.856 148.498 307.806 148.254 307.771 148.071C307.756 147.67 307.835 147.294 308.015 146.935C308.142 146.756 308.265 146.579 308.385 146.405C308.572 146.194 308.784 146.044 309.037 145.947L309.078 145.932L309.116 145.909C309.29 145.805 309.48 145.737 309.684 145.707L309.892 145.69H309.911L309.932 145.688Z",
    fill: "#AC1E58",
    stroke: "#AC1E58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.999 116.049C309.541 114.087 313.126 113.778 315.61 115.846L315.751 115.962C318.472 118.35 318.443 122.122 317.574 125.596L317.387 126.298C316.195 130.499 314.459 134.556 312.397 138.413L311.981 139.182L311.98 139.183C311.62 139.841 311.109 140.178 310.573 140.299C310.025 140.422 309.42 140.325 308.895 140.054C308.368 139.782 307.954 139.351 307.758 138.851C307.591 138.424 307.569 137.918 307.809 137.355L307.928 137.111C310.112 133.13 312.326 128.68 313.279 124.115L313.367 123.674C313.467 123.148 313.502 122.497 313.454 121.857C313.407 121.222 313.276 120.557 313.019 120.019C312.763 119.485 312.334 118.983 311.657 118.894C311.086 118.818 310.481 119.059 309.85 119.551L309.577 119.777C308.683 120.565 308.356 121.685 308.27 122.767C308.204 123.578 308.272 124.413 308.362 125.148L308.457 125.846C308.565 126.591 308.353 127.116 308.014 127.467C307.662 127.83 307.128 128.051 306.534 128.084C305.412 128.147 304.262 127.55 303.95 126.295L303.899 126.035C303.378 122.459 303.973 118.602 306.726 116.27L306.999 116.049Z",
    fill: "black",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.669 386.175C464.081 386.155 464.467 386.233 464.836 386.417C465.013 386.544 465.189 386.665 465.362 386.784C465.636 387.045 465.837 387.353 465.962 387.707C465.999 387.911 466.05 388.158 466.084 388.342C466.111 388.638 466.068 388.908 465.949 389.163L465.93 389.205L465.919 389.249C465.849 389.52 465.715 389.757 465.509 389.968L465.498 389.979L465.488 389.989C465.299 390.208 465.082 390.362 464.824 390.461L464.783 390.477L464.745 390.499C464.513 390.638 464.254 390.713 463.97 390.718H463.639C463.226 390.738 462.84 390.659 462.471 390.475C462.293 390.348 462.117 390.226 461.944 390.107C461.67 389.846 461.468 389.538 461.344 389.184C461.306 388.979 461.257 388.73 461.223 388.547C461.196 388.253 461.24 387.984 461.358 387.729L461.378 387.688L461.389 387.644C461.459 387.373 461.593 387.135 461.799 386.925L461.81 386.914L461.819 386.903C462.009 386.685 462.225 386.531 462.483 386.433L462.524 386.417L462.562 386.395C462.737 386.29 462.926 386.222 463.13 386.192L463.338 386.176H463.656L463.669 386.175Z",
    fill: "#AC1E58",
    stroke: "#AC1E58"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1133_68"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 747,
    height: 453,
    fill: "white",
    transform: "translate(0 0.929688)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoChatHistory);
export default __webpack_public_path__ + "static/media/no-chat-history.7c16d88e7caa3a07d33aaac81fddb5da.svg";
export { ForwardRef as ReactComponent };